// import moment from 'moment';
import { Hatch, Domifier, SafeString } from "../classes/Hatch";
import close from "@icons/close.svg";

import Utils, { wait } from "../classes/Utils";
class NotificationMessage {
  dom: Element;
  count: number;
  props: {
    time: number;
    title: string;
    message: string;
    icon: string;
    type: string;
    dismiss: string;
    timer: number;
  };

  constructor(n = {}) {
    this.dom = null;
    this.count = 1;
    this.props = {
      time: new Date().getTime(),
      title: "Information",
      message: "",
      icon: "info-square",
      type: "",
      dismiss: "Dismiss",
      timer: 15000,
      ...n,
    };
  }

  // generates DOM for this notification
  render() {
    this.dom = Domifier(
      Hatch`
      <div class="toast ${this.props.type}" data-notification>
        <h4>${this.props.title}</h4>
        <p>${this.props.message}</p>
        <button class="" data-close-toast>${new SafeString(close)}</button>
        <span class="timer" style="animation-duration:${this.props.timer}ms;"></span>
      </div>
    `.toString()
    );

    return this.dom;
  }

  bind() {
    // set click listener on dismiss button
    this.dom.querySelector("[data-close-toast]").addEventListener("click", (e) => {
      e.preventDefault();
      this.remove();
    });
  }

  insert() {
    return new Promise((resolve) => {
      wait(100).then(() => {
        this.dom.classList.add("in");
        if (this.props.timer !== 0 || this.props.timer !== null) wait(this.props.timer).then(() => this.remove());
        wait(500).then(() => {
          resolve(null);
        });
      });
    });
  }

  increment() {
    this.count += 1;
    if (this.dom) {
      let counter = this.dom.querySelector("[data-box-counter]");
      if (!counter.classList.contains("badge")) counter.classList.add("badge");
      counter.textContent = this.count.toString();
    }
  }

  remove() {
    return new Promise((resolve) => {
      if (this.dom) this.dom.classList.remove("in");
      wait(500).then(() => {
        if (this.dom) this.dom.parentElement.removeChild(this.dom);
        this.dom = null;
        resolve(null);
      });
    });
  }

  get hash() {
    return Utils.Hash(`${this.props.title}_${this.props.message}`);
  }
}

/*
  A notification service that pops messages to the DOM.
 */
export default class NotificationCenter {
  props: {
    parent: Element;
  };
  notifications: any;

  constructor(props = {}) {
    this.props = {
      parent: null,
      ...props,
    };
    this.notifications = [];
  }

  notify(props = {}, silent = false) {
    let n = new NotificationMessage(props);
    // this.notifications.push(n);

    if (silent !== true) {
      let body = n.render();
      this.parent.appendChild(body);
      n.bind();
      n.insert();
    }
  }
  get parent() {
    return this.props.parent;
  }
}

export { NotificationMessage };
